export class DepthCategory {
    id: number;
    depthCategoryDescription: string;
    displayName: string

    constructor(id, displayName) {
        this.id = id;
        this.displayName = displayName;
    }
}


// WEBPACK FOOTER //
// ./src/app/modules/search/entities/depthCategory.ts